import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import ReactApexChart from 'react-apexcharts';
import { labelStyle, responsiveFun, lgXaxisLabels } from '../options';
import trans from '../../translations.json';
import ReducedData from '../../reducedData.json';
import { DownloadButton } from '../options';
import { ButtonGroup } from '../buttonGroup/buttonGroup';
import { ToolTipClone } from '../toolTipClone/toolTipClone';
import ActiveOutbreaksTable from './activeOutbreaks-table.jsx';

const viewModes = {
  graph: 'graph',
  table: 'table',
};

const colours = [
  // group care
  '#E3C7C5',
  '#D0908C',
  '#99716F',
  //group living
  '#FEE9C0',
  '#FDD482',
  '#FCAF17',
  '#D1AA5C',
  '#A97B20',

  // education
  '#CBE3AA',
  '#B2DE76',
  '#8DC640',
  '#62892D',
  '#416017',

  // recreational
  '#BAC9DF',
  '#96B8E9',
  '#5379AF',
  '#4C586A',

  //workplace
  '#E0C8E0',
  '#B992B8',
  '#A163A0',
  '#92278F',
  '#4D164B',

  // unknown or other
  '#CCCCCC',
  '#666666',
];
class ActiveOutbreaks extends Component {
  state = {
    settingsCategories: [
      trans.activeOutbreaks.groupCare[this.props.lang],
      trans.activeOutbreaks.groupLiving[this.props.lang],
      trans.activeOutbreaks.groupEducation[this.props.lang],
      trans.activeOutbreaks.groupRecreational[this.props.lang],
      trans.activeOutbreaks.groupWorkplace[this.props.lang],
      trans.activeOutbreaks.groupOther[this.props.lang],
    ],
    ready: false,
    series: [{}],
    options: {},
    selectedViewMode: viewModes.graph,
  };

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.init();
    }
  }

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  init() {
    var data = ReducedData.dataActiveOutbreaks;
    var keys = Object.keys(ReducedData.dataActiveOutbreaks);
    let seriesAll = [];
    keys.forEach((setting) => {
      seriesAll.push({
        name: setting,
        data: [5, 3, 2, 4, 7],
      });
    });

    let tooltipSettingsData = [
      [
        {
          label: '1 Long-Term Care Homes',
          value: Number(
            data['1 Long-Term Care Homes'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '2 Hospitals',
          value: Number(
            data['2 Hospitals']['NUMBER OF ONGOING OUTBREAKS'],
          ),
        },
        {
          label: '3 Retirement Homes',
          value: Number(
            data['3 Retirement Homes']['NUMBER OF ONGOING OUTBREAKS'],
          ),
        },
      ],
      [
        {
          label: '4 Group Home/Supportive Housing',
          value: Number(
            data['4 Group Home/Supportive Housing'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '5 Correctional Facility',
          value: Number(
            data['5 Correctional Facility'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '6 Shelter',
          value: Number(
            data['6 Shelter']['NUMBER OF ONGOING OUTBREAKS'],
          ),
        },
        {
          label: '18 Short-term accommodations',
          value: Number(
            data['18 Short-term accommodations'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '22 Congregate other',
          value: Number(
            data['22 Congregate other'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
      ],
      [
        {
          label: '11 Child care',
          value: Number(
            data['11 Child care']['NUMBER OF ONGOING OUTBREAKS'],
          ),
        },
        {
          label: '7 School - Elementary',
          value: Number(
            data['7 School - Elementary'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '8 School - Secondary',
          value: Number(
            data['8 School - Secondary'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '9 School - Elementary/Secondary',
          value: Number(
            data['9 School - Elementary/Secondary'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '10 School - Post-Secondary',
          value: Number(
            data['10 School - Post-Secondary'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
      ],
      [
        {
          label: '17 Bar/restaurant/nightclub',
          value: Number(
            data['17 Bar/restaurant/nightclub'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '19 Recreational fitness',
          value: Number(
            data['19 Recreational fitness'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '20 Personal service settings',
          value: Number(
            data['20 Personal service settings'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '21 Other recreation',
          value: Number(
            data['21 Other recreation'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
      ],
      [
        {
          label: '12 Workplace - Farm',
          value: Number(
            data['12 Workplace - Farm'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '13 Workplace - Food Processing',
          value: Number(
            data['13 Workplace - Food Processing'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '15 Retail',
          value: Number(
            data['15 Retail']['NUMBER OF ONGOING OUTBREAKS'],
          ),
        },
        {
          label: '16 Medical/Health Service',
          value: Number(
            data['16 Medical/Health Service'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
        {
          label: '14 Workplace - Other',
          value: Number(
            data['14 Workplace - Other'][
              'NUMBER OF ONGOING OUTBREAKS'
            ],
          ),
        },
      ],
      [
        {
          label: '24 Unknown',
          value: Number(
            data['24 Unknown']['NUMBER OF ONGOING OUTBREAKS'],
          ),
        },
        {
          label: '23 Other',
          value: Number(
            data['23 Other']['NUMBER OF ONGOING OUTBREAKS'],
          ),
        },
      ],
    ];

    let series = [
      {
        name: tooltipSettingsData[0][0].label,
        data: [tooltipSettingsData[0][0].value, 0, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[0][1].label,
        data: [tooltipSettingsData[0][1].value, 0, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[0][2].label,
        data: [tooltipSettingsData[0][2].value, 0, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[1][0].label,
        data: [0, tooltipSettingsData[1][0].value, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[1][1].label,
        data: [0, tooltipSettingsData[1][1].value, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[1][2].label,
        data: [0, tooltipSettingsData[1][2].value, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[1][3].label,
        data: [0, tooltipSettingsData[1][3].value, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[1][4].label,
        data: [0, tooltipSettingsData[1][4].value, 0, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[2][0].label,
        data: [0, 0, tooltipSettingsData[2][0].value, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[2][1].label,
        data: [0, 0, tooltipSettingsData[2][1].value, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[2][2].label,
        data: [0, 0, tooltipSettingsData[2][2].value, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[2][3].label,
        data: [0, 0, tooltipSettingsData[2][3].value, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[2][4].label,
        data: [0, 0, tooltipSettingsData[2][4].value, 0, 0, 0],
      },
      {
        name: tooltipSettingsData[3][0].label,
        data: [0, 0, 0, tooltipSettingsData[3][0].value, 0, 0],
      },
      {
        name: tooltipSettingsData[3][1].label,
        data: [0, 0, 0, tooltipSettingsData[3][1].value, 0, 0],
      },
      {
        name: tooltipSettingsData[3][2].label,
        data: [0, 0, 0, tooltipSettingsData[3][2].value, 0, 0],
      },
      {
        name: tooltipSettingsData[3][3].label,
        data: [0, 0, 0, tooltipSettingsData[3][3].value, 0, 0],
      },
      {
        name: tooltipSettingsData[4][0].label,
        data: [0, 0, 0, 0, tooltipSettingsData[4][0].value, 0],
      },
      {
        name: tooltipSettingsData[4][1].label,
        data: [0, 0, 0, 0, tooltipSettingsData[4][1].value, 0],
      },
      {
        name: tooltipSettingsData[4][2].label,
        data: [0, 0, 0, 0, tooltipSettingsData[4][2].value, 0],
      },
      {
        name: tooltipSettingsData[4][3].label,
        data: [0, 0, 0, 0, tooltipSettingsData[4][3].value, 0],
      },
      {
        name: tooltipSettingsData[4][4].label,
        data: [0, 0, 0, 0, tooltipSettingsData[4][4].value, 0],
      },
      {
        name: tooltipSettingsData[5][0].label,
        data: [0, 0, 0, 0, 0, tooltipSettingsData[5][0].value],
      },
      {
        name: tooltipSettingsData[5][1].label,
        data: [0, 0, 0, 0, 0, tooltipSettingsData[5][1].value],
      },
    ];
    this.initGraph(series, tooltipSettingsData);
  }

  initGraph(series, tooltipSettingsData) {
    const lang = this.props.lang;
    const settingsCategories = this.state.settingsCategories;
    this.setState({
      ready: true,
      series: [...series],
      stackOptions: {
        legend: {
          show: false,
        },
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },
          custom: function ({
            series,
            seriesIndex,
            dataPointIndex,
            w,
          }) {
            let colorIndex = 0;
            switch (dataPointIndex) {
              case 1:
                colorIndex = 3;
                break;
              case 2:
                colorIndex = 8;
                break;
              case 3:
                colorIndex = 13;
                break;
              case 4:
                colorIndex = 17;
                break;
              case 5:
                colorIndex = 22;
                break;
              default:
                break;
            }
            let toolTipData = [
              ...tooltipSettingsData[dataPointIndex].map(
                (item, i) => {
                  return {
                    label: trans.activeOutbreaks[item.label][lang],
                    value: item.value,
                    colour: colours[colorIndex + i],
                  };
                },
              ),
            ];
            const tooltipTitle = () => {
              return `${settingsCategories[dataPointIndex]}`;
            };

            return renderToString(
              ToolTipClone(tooltipTitle(), toolTipData),
            );
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text = '';
          item.options.chart.height = '350px';
          if (item.options.dataLabels)
            item.options.dataLabels.enabled = true;
          return item;
        }),
        states: {
          hover: {
            filter: {
              type: 'none',
            },
          },
        },
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          height: 650,
          width: '100%',
          stacked: true,
          type: 'bar',
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: true,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 20,
          style: { ...labelStyle },
          formatter: function (
            value,
            { seriesIndex, dataPointIndex, w },
          ) {
            let indices = w.config.series.map((item, i) => i);
            indices = indices.filter(
              (i) =>
                !w.globals.collapsedSeriesIndices.includes(i) &&
                w.config.series[i].data[dataPointIndex] > 0,
            );
            if (seriesIndex === indices[indices.length - 1]) {
              return lang === 'fr'
                ? w.globals.stackedSeriesTotals[
                    dataPointIndex
                  ].toLocaleString()
                : w.globals.stackedSeriesTotals[dataPointIndex]
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return '';
          },
        },
        colors: [
          function ({ value, seriesIndex, w }) {
            return colours[seriesIndex];
          },
        ],
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
          },
        },
        stroke: {
          width: 2,
          colors: ['#fff'],
        },
        yaxis: {
          labels: {
            style: { ...labelStyle },
          },
        },
        xaxis: {
          title: {
            offsetY: 20,
            text: trans.activeOutbreaks.xaxis[this.props.lang],
          },
          categories: this.state.settingsCategories,
          labels: {
            ...lgXaxisLabels,
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
      },
    });
  }

  render() {
    let hieghestDate = '10/10/2020';

    Object.values(ReducedData.dataActiveOutbreaks).forEach((item) => {
      if (new Date(item.Last_updated) > new Date(hieghestDate)) {
        hieghestDate = item.Last_updated;
      }
    });

    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <ReactApexChart
                options={this.state.stackOptions}
                series={this.state.series}
                type="bar"
                height="400px"
                aria-hidden="true"
              />
            </>
          );
        case viewModes.table:
          return <ActiveOutbreaksTable lang={this.props.lang} />;
        default:
      }
    };

    return (
      <div>
        <p
          dangerouslySetInnerHTML={{
            __html: trans.activeOutbreaks.desc[this.props.lang],
          }}
        ></p>
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default ActiveOutbreaks;
